import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionBoqItemsService } from '../services/constructionBoqItems.service';
import { toast } from 'sonner';

export function useDeleteBoqItem(boqId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (itemId: string) => ConstructionBoqItemsService.deleteBoqItem(itemId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-boqs', 'items', boqId] });
      queryClient.invalidateQueries({ queryKey: ['construction-boqs', 'stats', boqId] });
      toast.success('Xóa hạng mục thành công');
    },
    onError: (error: any) => {
      toast.error('Lỗi khi xóa: ' + error.message);
    }
  });
}
